import { MEMBERS_LOADING, MEMBERS_LOADED } from '../constants/ActionTypes';

const initialState = {
  loading: false,
  loaded: false,
  members: {},
};

export default function members(state = initialState, action) {
  switch (action.type) {
    case MEMBERS_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case MEMBERS_LOADED:
      return {
        ...state,
        loading: false,
        loaded: true,
        members: action.members,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/members.js